/*  
  This file has methods that use cheerio pacakge heavily for easy dom parsing - https://www.npmjs.com/package/cheerio. creating 
  variables with $ name can be looking bad and reminiscent of old school jquery, but doing it this way still as cheerio (heavily rated package) uses
  this convention and the api $('h2').length -- actually looks easy to read

  Note that cheerio will load with html tags wrapping if not present in input string - https://github.com/cheeriojs/cheerio/issues/1031#issuecomment-748677236 and https://github.com/cheeriojs/cheerio#loading
  
  Similar to web browser contexts, load will introduce <html>, <head>, and <body> elements if they are not already present. You can set load's third argument to false to disable this.

    const $ = cheerio.load('<ul id="fruits">...</ul>', null, false);

    $.html();
    //=> '<ul id="fruits">...</ul>'

*/

//  Needs to export a checks and a modify lists that the content will be passed through

// check functions should return true if check passes, else return false
import * as cheerio from 'cheerio';
// these check functions take cheerio object which is just like jquery $ and cheerio doc says to use $ to investigate and return true/false

const checkNoH1Tag = $ => {
  return $('h1').length === 0;
};

const checkEnoughH2Tags = $ => {
  return $('h2').length >= 2;
};

const checkEnoughH3Tags = $ => {
  return $('h3').length >= 3;
};

// these modify functions take a cheerio object and modify and return another cheerio object
const modifyAddImageFluid = $ => {
  $('img').addClass('img-fluid'); // the return of this addClass is not the full cheerio object ($), but $ is changed none the less, so return this in the next line
  return $;
};

export const modifyImgAttributes = ($, wpPostObject) => {
  $('img[alt=""]').each(function () {
    var newAlt = wpPostObject.title;
    $(this).attr('alt', newAlt);
  });

  $('img').each(function () {
    const title = $(this).attr('title');
    if (!title) {
      $(this).attr('title', wpPostObject.title);
    }
  });
  return $;
};

export const modifyAnchorTags = $ => {
  const baseURI =
    process.env.NODE_ENV === 'development'
      ? 'localhost:8000'
      : 'oasis-living.com';
  // Select all anchors not referencing the base URI.
  $(
    `a:not([href^="https://${baseURI}"],[href^="http://${baseURI}"],[href^="${baseURI}"])`,
  ).each(function () {
    $(this).attr('target', '_blank');
  });

  return $;
};

// eslint-disable-next-line
const modifyImageContainer = $ => {
  $('.gatsby-image-wrapper').wrap(`<div class="osl-image-wrapper"> </div>`);
  return $;
};

export const modifyFunctionList = [
  modifyAddImageFluid,
  modifyImageContainer,
  modifyImgAttributes,
  modifyAnchorTags,
];

// list of all check functions
export const checkFunctionList = [
  {
    handler: checkNoH1Tag,
    msg:
      'Blog content should not have H1 Tag, this is taken from the blog title',
  },
  { handler: checkEnoughH2Tags, msg: 'Not enough H2 Tags, need 2' },
  { handler: checkEnoughH3Tags, msg: 'Not enough H3 Tags, need 3' },
];

/**
 * Use the modifyFuncList to fix some issues in the html
 * @param {string} content The HTML string to be modified
 * @param {object} post The full user post
 * @returns {string} Modified HTML content
 */

export const modifyHTMLContent = (content = '', post = {}) => {
  const $ = cheerio.load(content, null, false); // initial cheerio content

  // todo: sam to change with new foreach
  modifyFunctionList.forEach(fn => {
    fn($, post);
  });

  return $.html();
};

/**
 * Ensure that Wordpress content are safe for compilation
 * @param {String} content
 * @returns {object}
 */
export const checkHTMLContent = content => {
  const $ = cheerio.load(content);

  const resultArr = checkFunctionList.map(checkFuncObj => {
    const isContentStructureCorrect = checkFuncObj.handler($);
    return {
      status: isContentStructureCorrect,
      msg: isContentStructureCorrect ? '' : checkFuncObj.msg,
    };
  });

  const allPassed = resultArr.every(res => res.status);
  const warningList = allPassed
    ? ''
    : resultArr
        .filter(res => !res.status)
        .map(res => res.msg)
        .join('\n');
  return {
    safe: allPassed,
    warningList: warningList,
  };
};
